import { render } from "./EndSession.vue?vue&type=template&id=5a3a079e"
import script from "./EndSession.vue?vue&type=script&lang=js"
export * from "./EndSession.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__